import { useCallback } from 'react';
import MunicipalPortalAAppService from 'application/platform/municipal-portal-service';
import { downloadFile } from 'utils/download-file';
import { useLicitacaoDetailsDispatch } from './licitacao-details-context';
import { ACTION_TYPES } from './licitacao-details-reducer';

export const useLicitacaoDetailsController = () => {
  const dispatch = useLicitacaoDetailsDispatch();

  const loadLicitacaoDetails = useCallback(async (id: number) => {
    try {
      dispatch({ type: ACTION_TYPES.setLoading, payload: true });
      dispatch({ type: ACTION_TYPES.setError, payload: null });

      const response = await MunicipalPortalAAppService.getLicitacao(id);

      dispatch({ type: ACTION_TYPES.setLicitacaoDetails, payload: response });
    } catch (error) {
      console.error('Error loading licitacao details:', error);
      dispatch({ type: ACTION_TYPES.setError, payload: 'Erro ao carregar detalhes da licitação' });
      dispatch({ type: ACTION_TYPES.setLicitacaoDetails, payload: null });
    } finally {
      dispatch({ type: ACTION_TYPES.setLoading, payload: false });
    }
  }, [dispatch]);

  const clearLicitacaoDetails = useCallback(() => {
    dispatch({ type: ACTION_TYPES.setLicitacaoDetails, payload: null });
    dispatch({ type: ACTION_TYPES.setError, payload: null });
  }, [dispatch]);

  const exportLicitacaoDetail = useCallback(async (id: number, format: string) => {
    const file = await MunicipalPortalAAppService.exportLicitacaoDetail(id, format);
    downloadFile(file);
  }, []);

  return {
    loadLicitacaoDetails,
    clearLicitacaoDetails,
    exportLicitacaoDetail,
  };
};
